import React from 'react';

interface StepHeaderProps {
  text: string;
}

const StepHeader: React.FC<StepHeaderProps> = (props) => {
  return <div className="b-typography-serif--headline--500">{props.text}</div>;
};

export default StepHeader;
